<template>
    <div class="hello-page-wrapper career-page-wrapper expert-page-wrapper" :class="{'bodyfont-unauth': !user}">
        <div class="featured main" v-if="getExpert && expertInfo">
            <div class="container">
                <div class="row margin-top-40">
                    <div class="col-sm-5">
                        <img class="img-responsive" v-bind:src="expertInfo.large_image" :alt="expertInfo.name" :title="expertInfo.name">
                    </div>
                    <div class="col-sm-7">
                        <div class="row">
                            <div class="experts">
                                <h2>
                                    {{expertInfo.name}}
                                </h2>
                                <p class="title">
                                    ({{expertInfo.experties}})
                                </p>
                                <p class="desc" v-html="expertInfo.biography">
                                    <!--//{{getExpert[0].biography}}-->
                                </p>
                                <!--<p class="desc">-->
                                    <!--{{getExpert[0].areasofexpertise}}-->
                                <!--</p>-->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="live-chat" v-if="expertEvent">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <h2 class="live-chat-heading pinkh2" v-bind:style="{ color: $a11yInkColor(getCorpHeadingColor) + ' !important' } ">Upcoming <span v-if="expertEvent.type === '1'">TONE Live</span><span v-else>TONE Talk</span> Event</h2>
                    </div>
                    <div class="col-md-12 pinkbordercomp" v-if="expertEvent && showJoin(expertEvent)">
                        <rulescomp v-if="expertEvent" :data="expertEvent" v-bind:style="{border: '1px solid ' + getCorpHeaderColor}">Loading event rules</rulescomp>
                    </div>
                </div>
                <div class="row margin-top-40">
                    <div class="col-md-6 col-md-offset-1" v-if="getExpert">
<!--                        <img class="nostyle" src="../assets/tone-event-banner.png" alt="TONE EVENT BANNER" :title="expertEvent.title">-->
                        <img v-bind:src="expertEvent.img_url" alt="EVENT BANNER" :title="expertEvent.title" />
                    </div>
                    <div class="col-md-4">
                        <div class="row">
                            <div class="experts" v-if="getExpert && expertInfo">
                                <h2>
                                    Join an Exclusive <span v-if="expertEvent.type === '1'">TONE Live</span><span v-else>TONE Talk</span> Event with {{replaceLastExpert(expertEvent.csvExpertsNames, ',', ' & ' )}}
                                </h2>
                                <p>
                                    {{expertEvent.longDescription}}
                                </p>
                                <p class="date">
                                    {{getDateReference(expertEvent.start_date, 'str')}}
                                </p>
                                <div title="Add to Calendar" class="addeventatc pinkoutlinebtn" v-if="!showJoin(expertEvent)" v-bind:style="{ color: getCorpButtonColor + ' !important', border: '1px solid ' + getCorpButtonColor}">
                                    Add to Calendar
                                    <span class="start">{{expertEvent.start_date}}</span>
                                    <span class="end">{{expertEvent.end_date}}</span>
                                    <span class="timezone">America/New_York</span>
                                    <span class="title">{{expertEvent.title}}</span>
                                    <span class="description">{{expertEvent.longDescription}}</span>
                                    <span class="location"><span v-if="expertEvent.type === '1'">{{eventURL}}/event/{{expertEvent.eventId}}</span><span v-else>{{eventURL}}/event/{{expertEvent.eventId}}</span></span>
                                </div>
                                <button v-if="(user && user.corporation && user.corporation.corpSharingPermissions && user.corporation.corpSharingPermissions.corpEventShareOptnPermission >= 1)" @click="openCorporateImageShareModal(expertEvent)" type="button" class="share-event" v-bind:style="{color: $a11yInkColor(getCorpButtonColor) + ' !important', borderWidth: '1px !important', borderStyle: 'solid !important', borderColor: getCorpButtonColor + ' !important'}">
                                    <i aria-hidden="true" class="fa fa-share-square-o"></i> Share
                                </button>
                                <!--<div v-if="user">-->
                                    <!--<button class="btn btn-danger expert-section-btn btn-transparent btn-lg"  type="button" v-if="isUserEntrolled(expertEvent.eventId)"><i class="fa 2x fa-check" aria-hidden="true"></i>&nbsp;Reserved&nbsp;</button>-->
                                    <!--<button class="btn btn-danger expert-section-btn btn-transparent btn-lg" v-if="!isUserEntrolled(expertEvent.eventId)" @click="enrollUser(expertEvent)" type="button">Reserve your spot</button>-->
                                <!--</div>-->
                                <!--<div v-else>-->
                                    <!--<button class="btn btn-danger expert-section-btn btn-transparent btn-lg" @click="$router.push('/')">Sign up or log in to reserve your spot</button>-->
                                <!--</div>-->
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 pinkbordercomp" v-if="expertEvent && !showJoin(expertEvent)">
                        <rulescomp v-if="expertEvent" :data="expertEvent" v-bind:style="{border: '1px solid ' + getCorpHeaderColor}">Loading event rules</rulescomp>
                    </div>
                </div>
            </div>
        </div>
        <div class="container" v-else>
            <div class="row" v-if="getExpertVideos">
                <div class="col-md-12" v-if="getExpert && expertMainVideo && expertInfo">
                    <h2 class="pinkh2" v-bind:style="{ color: $a11yInkColor(getCorpHeadingColor) + ' !important' } ">MEET {{expertInfo.name}}</h2>
                </div>
                <div class="col-sm-6 col-sm-offset-3" v-if="expertMainVideo">
                    <jwplayer id="expertMainVid" :data="expertMainVideo">Loading the player...</jwplayer>
                    <h3><i aria-hidden="true" class="fa fa-play"></i>&nbsp;{{expertMainVideo.title}}</h3>
                </div>
            </div>
        </div>
        <div class="random" v-if="getExpertVideos">
            <div class="container">
                <div class="margin-top-40">
                    <div class="blog-section videossection clearfix">
                        <div class="row" v-if="getExpert">
                            <div class="col-md-12 margin-bottom-40">
                                <h2 class="text-center pinkh2" v-bind:style="{ color: $a11yInkColor(getCorpHeadingColor) + ' !important' } ">MOST POPULAR VIDEOS FROM {{expertInfo.name}}</h2>
                            </div>
                        </div>
                        <div class="row random-section-head yourFaves exceptionalsettings">
                            <div class="col-xs-12 col-sm-6 col-md-4 bottom-margin" :class="{'innerimggray': getTrialDays < 0}"  v-if="getExpertVideos[1]">
                                <a :href="'/watch/' + getExpertVideos[1].mediaid + '/' + getExpertVideos[1].title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
" class="nounderline">
                                        <img class="jw-img" :src="getExpertVideos[1].image"  :alt="getExpertVideos[1].title" :title="getExpertVideos[1].title" />
                                            <p class="text-wrap-title cursor" v-if="getExpertVideos[1].marketing" > <i aria-hidden="true" class="fa fa-play-circle-o"></i><strong>{{getExpertVideos[1].title}}</strong></p>
                                            <p class="text-wrap-title cursor" v-if="!getExpertVideos[1].marketing"> <i aria-hidden="true" class="fa fa-play-circle-o"></i>{{getExpertVideos[1].title}}</p>
                                </a>
                                            <hr v-if="user && !getExpertVideos[1].marketing">
                                            <div class="plusicon btn-group" v-if="user && !getExpertVideos[1].marketing">
                                                <button aria-label="Add video to a playlist" title="Add to Playlist" :id="getExpertVideos[1].mediaid" type="button" @click="showPlaylistMenu(getExpertVideos[1].mediaid)" class="dropdown-toggle ellipsis pull-right">
<!--                                                    <img src="../assets/playlist-icon.png" class="menuiconbutton" alt="PLAYLIST" title="Playlist"/>-->
                                                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                                         width="37px" height="24px" viewBox="0 0 37 24" enable-background="new 0 0 37 24" xml:space="preserve">
<rect y="0.2" :fill="getCorpHeaderColor" width="25" height="3"/>
                                                        <rect y="8.2" :fill="getCorpHeaderColor" width="25" height="3"/>
                                                        <rect y="17.2" :fill="getCorpHeaderColor" width="18.2" height="3"/>
                                                        <rect x="23" y="15.2" :fill="getCorpHeaderColor" width="14" height="4"/>
                                                        <rect x="27.958" y="10.242" :fill="getCorpHeaderColor" width="4" height="13.917"/>
</svg>
                                                </button>
                                                <ul class="hide">
                                                    <li  v-if="getUserPlaylists">
                                                        <label>
                                                            <b> Add to ...</b>
                                                        </label>
                                                    </li>
                                                    <li role="separator" class="divider"  v-if="getUserPlaylists"></li>
                                                    <li  v-if="getUserPlaylists" v-for="playlist in getUserPlaylists">
                                                        <label class="notificationwithcheckboxes">
                                                            <input type="checkbox" :checked="verifyVideoExists(playlist, getExpertVideos[1])" @click="setPlaylistVideoStatus(getExpertVideos[1], playlist, verifyVideoExists(playlist, getExpertVideos[1])) "/> {{playlist.title}}
                                                            <transition name="fade">
                                                                <!--<h6 v-if="video.mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoAdded">Added</h6>-->
                                                                <span class="added" v-if="getExpertVideos[1].mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoAdded">Added</span>
                                                            </transition>
                                                            <transition name="fade">
                                                                <span class="removed" v-if="getExpertVideos[1].mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoRemoved">Removed</span>
                                                            </transition>
                                                        </label>
                                                    </li>
                                                    <!--<li>-->
                                                    <!--<label>-->
                                                    <!--<input type="checkbox" /> Second option-->
                                                    <!--</label>-->
                                                    <!--</li>-->
                                                    <!--<li>-->
                                                    <!--<label>-->
                                                    <!--<input type="checkbox" /> Third option-->
                                                    <!--</label>-->
                                                    <!--</li>-->
                                                    <!--<li>-->
                                                    <!--<label>-->
                                                    <!--<input type="checkbox" /> Forth option-->
                                                    <!--</label>-->
                                                    <!--</li>-->
                                                    <li role="separator" class="divider" v-if="getUserPlaylists"></li>
                                                    <li><label style="color:#f0617d">Create new playlist</label></li>
                                                    <li><label>  <input aria-label="New playlist name" type="text" class="form-control" v-model="newPlaylistName" />
                                                        <i v-a11y-action aria-label="Insert New Playlist" class="fa fa-plus-circle" @click="addNewPlayList" title="Insert New Playlist"></i>

                                                    </label> </li>
                                                </ul>
                                                <div class="backdropformenu"  @click="hidePlaylistMenu(getExpertVideos[1].mediaid)"></div>
                                            </div>
                                            <p class="right-heart-icon" v-if="user && !getExpertVideos[1].marketing">
                                                <a v-a11y-action aria-label="Liked this video?" href="javascript:" @click="setVideoStatus(getExpertVideos[1])" title ="Liked this video?">
                                                    <i class="fa fa-2x fa-heart-o" v-bind:style="{ color: getCorpHeaderColor}"
                                                       v-bind:class="{'activeIcons': getVideoStatus(getExpertVideos[1])}" aria-hidden="true" ></i></a>
                                            </p>

                            </div>
                            <div class="col-xs-12 col-sm-6 col-md-4 bottom-margin" :class="{'innerimggray': getTrialDays < 0}"  v-if="getExpertVideos[4]">
                                <a :href="'/watch/' + getExpertVideos[4].mediaid + '/' + getExpertVideos[4].title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()" class="nounderline">
                                        <img class="jw-img" :src="getExpertVideos[4].image" :alt="getExpertVideos[4].title" :title="getExpertVideos[4].title" />
                                          <p   class="text-wrap-title cursor" v-if="getExpertVideos[4].marketing"> <i aria-hidden="true" class="fa fa-play-circle-o"></i><strong>{{getExpertVideos[4].title}}</strong></p>
                                          <p  class="text-wrap-title cursor" v-if="!getExpertVideos[4].marketing"> <i aria-hidden="true" class="fa fa-play-circle-o"></i>{{getExpertVideos[4].title}}</p>
                                </a>
                                    <hr v-if="user && !getExpertVideos[4].marketing">
                                            <div class="plusicon btn-group" v-if="user && !getExpertVideos[4].marketing">
                                                <button aria-label="Add video to a playlist" title="Add to Playlist" :id="getExpertVideos[4].mediaid" type="button" @click="showPlaylistMenu(getExpertVideos[4].mediaid)" class="dropdown-toggle ellipsis pull-right">
<!--                                                    <img src="../assets/playlist-icon.png" class="menuiconbutton" alt="PLAYLIST" title="Playlist"/>-->
                                                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                                         width="37px" height="24px" viewBox="0 0 37 24" enable-background="new 0 0 37 24" xml:space="preserve">
<rect y="0.2" :fill="getCorpHeaderColor" width="25" height="3"/>
                                                        <rect y="8.2" :fill="getCorpHeaderColor" width="25" height="3"/>
                                                        <rect y="17.2" :fill="getCorpHeaderColor" width="18.2" height="3"/>
                                                        <rect x="23" y="15.2" :fill="getCorpHeaderColor" width="14" height="4"/>
                                                        <rect x="27.958" y="10.242" :fill="getCorpHeaderColor" width="4" height="13.917"/>
</svg>
                                                </button>
                                                <ul class="hide">
                                                    <li  v-if="getUserPlaylists">
                                                        <label>
                                                            <b> Add to ...</b>
                                                        </label>
                                                    </li>
                                                    <li role="separator" class="divider"  v-if="getUserPlaylists"></li>
                                                    <li  v-if="getUserPlaylists" v-for="playlist in getUserPlaylists">
                                                        <label class="notificationwithcheckboxes">
                                                            <input type="checkbox" :checked="verifyVideoExists(playlist, getExpertVideos[4])" @click="setPlaylistVideoStatus(getExpertVideos[4], playlist, verifyVideoExists(playlist, getExpertVideos[4])) "/> {{playlist.title}}
                                                            <transition name="fade">
                                                                <!--<h6 v-if="video.mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoAdded">Added</h6>-->
                                                                <span class="added" v-if="getExpertVideos[4].mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoAdded">Added</span>
                                                            </transition>
                                                            <transition name="fade">
                                                                <span class="removed" v-if="getExpertVideos[4].mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoRemoved">Removed</span>
                                                            </transition>
                                                        </label>
                                                    </li>
                                                    <!--<li>-->
                                                    <!--<label>-->
                                                    <!--<input type="checkbox" /> Second option-->
                                                    <!--</label>-->
                                                    <!--</li>-->
                                                    <!--<li>-->
                                                    <!--<label>-->
                                                    <!--<input type="checkbox" /> Third option-->
                                                    <!--</label>-->
                                                    <!--</li>-->
                                                    <!--<li>-->
                                                    <!--<label>-->
                                                    <!--<input type="checkbox" /> Forth option-->
                                                    <!--</label>-->
                                                    <!--</li>-->
                                                    <li role="separator" class="divider" v-if="getUserPlaylists"></li>
                                                    <li><label style="color:#f0617d">Create new playlist</label></li>
                                                    <li><label>  <input aria-label="New playlist name" type="text" class="form-control" v-model="newPlaylistName" />
                                                        <i v-a11y-action aria-label="Insert New Playlist" class="fa fa-plus-circle" @click="addNewPlayList" title="Insert New Playlist"></i>

                                                    </label> </li>
                                                </ul>
                                                <div class="backdropformenu"  @click="hidePlaylistMenu(getExpertVideos[4].mediaid)"></div>
                                            </div>
                                            <p class="right-heart-icon" v-if="user && !getExpertVideos[4].marketing">
                                                <a v-a11y-action aria-label="Liked this video?" href="javascript:" @click="setVideoStatus(getExpertVideos[4])" title ="Liked this video?">
                                                    <i class="fa fa-2x fa-heart-o" v-bind:style="{ color: getCorpHeaderColor}"
                                                       v-bind:class="{'activeIcons': getVideoStatus(getExpertVideos[4])}" aria-hidden="true" ></i></a>
                                            </p>
                            </div >
                            <div class="col-xs-12 col-sm-6 col-md-4 bottom-margin" :class="{'innerimggray': getTrialDays < 0}"  v-if="getExpertVideos[2]">
                                <a :href="'/watch/' + getExpertVideos[2].mediaid + '/' + getExpertVideos[2].title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()" class="nounderline">
                                        <img class="jw-img" :src="getExpertVideos[2].image"  :alt="getExpertVideos[2].title" :title="getExpertVideos[2].title"/>
                                            <p class="text-wrap-title cursor"  v-if="getExpertVideos[2].marketing"> <i aria-hidden="true" class="fa fa-play-circle-o"></i><strong>{{getExpertVideos[2].title}}</strong></p>
                                            <p class="text-wrap-title cursor"  v-if="!getExpertVideos[2].marketing"> <i aria-hidden="true" class="fa fa-play-circle-o"></i>{{getExpertVideos[2].title}}</p>
                                </a>
                                <hr v-if="user && !getExpertVideos[2].marketing">
                                <div class="plusicon btn-group" v-if="user && !getExpertVideos[2].marketing">
                                    <button aria-label="Add video to a playlist" title="Add to Playlist" :id="getExpertVideos[2].mediaid" type="button" @click="showPlaylistMenu(getExpertVideos[2].mediaid)" class="dropdown-toggle ellipsis pull-right">
<!--                                        <img src="../assets/playlist-icon.png" class="menuiconbutton" alt="PLAYLIST" title="Playlist"/>-->
                                        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                             width="37px" height="24px" viewBox="0 0 37 24" enable-background="new 0 0 37 24" xml:space="preserve">
<rect y="0.2" :fill="getCorpHeaderColor" width="25" height="3"/>
                                            <rect y="8.2" :fill="getCorpHeaderColor" width="25" height="3"/>
                                            <rect y="17.2" :fill="getCorpHeaderColor" width="18.2" height="3"/>
                                            <rect x="23" y="15.2" :fill="getCorpHeaderColor" width="14" height="4"/>
                                            <rect x="27.958" y="10.242" :fill="getCorpHeaderColor" width="4" height="13.917"/>
</svg>
                                    </button>
                                    <ul class="hide">
                                        <li  v-if="getUserPlaylists">
                                            <label>
                                                <b> Add to ...</b>
                                            </label>
                                        </li>
                                        <li role="separator" class="divider"  v-if="getUserPlaylists"></li>
                                        <li  v-if="getUserPlaylists" v-for="playlist in getUserPlaylists">
                                            <label class="notificationwithcheckboxes">
                                                <input type="checkbox" :checked="verifyVideoExists(playlist, getExpertVideos[2])" @click="setPlaylistVideoStatus(getExpertVideos[2], playlist, verifyVideoExists(playlist, getExpertVideos[2])) "/> {{playlist.title}}
                                                <transition name="fade">
                                                    <!--<h6 v-if="video.mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoAdded">Added</h6>-->
                                                    <span class="added" v-if="getExpertVideos[2].mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoAdded">Added</span>
                                                </transition>
                                                <transition name="fade">
                                                    <span class="removed" v-if="getExpertVideos[2].mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoRemoved">Removed</span>
                                                </transition>
                                            </label>
                                        </li>
                                        <!--<li>-->
                                        <!--<label>-->
                                        <!--<input type="checkbox" /> Second option-->
                                        <!--</label>-->
                                        <!--</li>-->
                                        <!--<li>-->
                                        <!--<label>-->
                                        <!--<input type="checkbox" /> Third option-->
                                        <!--</label>-->
                                        <!--</li>-->
                                        <!--<li>-->
                                        <!--<label>-->
                                        <!--<input type="checkbox" /> Forth option-->
                                        <!--</label>-->
                                        <!--</li>-->
                                        <li role="separator" class="divider" v-if="getUserPlaylists"></li>
                                        <li><label style="color:#f0617d">Create new playlist</label></li>
                                        <li><label>  <input aria-label="New playlist name" type="text" class="form-control" v-model="newPlaylistName" />
                                            <i v-a11y-action aria-label="Insert New Playlist" class="fa fa-plus-circle" @click="addNewPlayList" title="Insert New Playlist"></i>

                                        </label> </li>
                                    </ul>
                                    <div class="backdropformenu"  @click="hidePlaylistMenu(getExpertVideos[2].mediaid)"></div>
                                </div>
                                <p class="right-heart-icon" v-if="user && !getExpertVideos[2].marketing">
                                    <a v-a11y-action aria-label="Liked this video?" href="javascript:" @click="setVideoStatus(getExpertVideos[2])" title ="Liked this video?">
                                        <i class="fa fa-2x fa-heart-o" v-bind:style="{ color: getCorpHeaderColor}"
                                           v-bind:class="{'activeIcons': getVideoStatus(getExpertVideos[2])}" aria-hidden="true" ></i></a>
                                </p>

                            </div>
                            <div class="col-xs-12 col-sm-6 col-md-4 bottom-margin" :class="{'innerimggray': getTrialDays < 0}"  v-if="getExpertVideos[5]">
                                <a :href="'/watch/' + getExpertVideos[5].mediaid + '/' + getExpertVideos[5].title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()" class="nounderline">
                                        <img class="jw-img" :src="getExpertVideos[5].image"  :alt="getExpertVideos[5].title" :title="getExpertVideos[5].title"/>
                                            <p class="text-wrap-title cursor" v-if="getExpertVideos[5].marketing"> <i aria-hidden="true" class="fa fa-play-circle-o"></i><strong>{{getExpertVideos[5].title}}</strong></p>
                                            <p class="text-wrap-title cursor"  v-if="!getExpertVideos[5].marketing"> <i aria-hidden="true" class="fa fa-play-circle-o"></i>{{getExpertVideos[5].title}}</p>
                                </a>
                                            <hr v-if="user && !getExpertVideos[5].marketing">
                                            <div class="plusicon btn-group" v-if="user && !getExpertVideos[5].marketing">
                                                <button aria-label="Add video to a playlist" title="Add to Playlist" :id="getExpertVideos[5].mediaid" type="button" @click="showPlaylistMenu(getExpertVideos[5].mediaid)" class="dropdown-toggle ellipsis pull-right">
<!--                                                    <img src="../assets/playlist-icon.png" class="menuiconbutton" alt="PLAYLIST" title="Playlist"/>-->
                                                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                                         width="37px" height="24px" viewBox="0 0 37 24" enable-background="new 0 0 37 24" xml:space="preserve">
<rect y="0.2" :fill="getCorpHeaderColor" width="25" height="3"/>
                                                        <rect y="8.2" :fill="getCorpHeaderColor" width="25" height="3"/>
                                                        <rect y="17.2" :fill="getCorpHeaderColor" width="18.2" height="3"/>
                                                        <rect x="23" y="15.2" :fill="getCorpHeaderColor" width="14" height="4"/>
                                                        <rect x="27.958" y="10.242" :fill="getCorpHeaderColor" width="4" height="13.917"/>
</svg>
                                                </button>
                                                <ul class="hide">
                                                    <li  v-if="getUserPlaylists">
                                                        <label>
                                                            <b> Add to ...</b>
                                                        </label>
                                                    </li>
                                                    <li role="separator" class="divider"  v-if="getUserPlaylists"></li>
                                                    <li  v-if="getUserPlaylists" v-for="playlist in getUserPlaylists">
                                                        <label class="notificationwithcheckboxes">
                                                            <input type="checkbox" :checked="verifyVideoExists(playlist, getExpertVideos[5])" @click="setPlaylistVideoStatus(getExpertVideos[5], playlist, verifyVideoExists(playlist, getExpertVideos[5])) "/> {{playlist.title}}
                                                            <transition name="fade">
                                                                <!--<h6 v-if="video.mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoAdded">Added</h6>-->
                                                                <span class="added" v-if="getExpertVideos[5].mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoAdded">Added</span>
                                                            </transition>
                                                            <transition name="fade">
                                                                <span class="removed" v-if="getExpertVideos[5].mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoRemoved">Removed</span>
                                                            </transition>
                                                        </label>
                                                    </li>
                                                    <!--<li>-->
                                                    <!--<label>-->
                                                    <!--<input type="checkbox" /> Second option-->
                                                    <!--</label>-->
                                                    <!--</li>-->
                                                    <!--<li>-->
                                                    <!--<label>-->
                                                    <!--<input type="checkbox" /> Third option-->
                                                    <!--</label>-->
                                                    <!--</li>-->
                                                    <!--<li>-->
                                                    <!--<label>-->
                                                    <!--<input type="checkbox" /> Forth option-->
                                                    <!--</label>-->
                                                    <!--</li>-->
                                                    <li role="separator" class="divider" v-if="getUserPlaylists"></li>
                                                    <li><label style="color:#f0617d">Create new playlist</label></li>
                                                    <li><label>  <input aria-label="New playlist name" type="text" class="form-control" v-model="newPlaylistName" />
                                                        <i v-a11y-action aria-label="Insert New Playlist" class="fa fa-plus-circle" @click="addNewPlayList" title="Insert New Playlist"></i>

                                                    </label> </li>
                                                </ul>
                                                <div class="backdropformenu"  @click="hidePlaylistMenu(getExpertVideos[5].mediaid)"></div>
                                            </div>
                                            <p class="right-heart-icon" v-if="user && !getExpertVideos[5].marketing">
                                                <a v-a11y-action aria-label="Liked this video?" href="javascript:" @click="setVideoStatus(getExpertVideos[5])" title ="Liked this video?">
                                                    <i class="fa fa-2x fa-heart-o" v-bind:style="{ color: getCorpHeaderColor}"
                                                       v-bind:class="{'activeIcons': getVideoStatus(getExpertVideos[5])}" aria-hidden="true" ></i></a>
                                            </p>
                            </div>
                            <div class="col-xs-12 col-sm-6 col-md-4 bottom-margin" :class="{'innerimggray': getTrialDays < 0}"  v-if="getExpertVideos[3]">
                                <a :href="'/watch/' + getExpertVideos[3].mediaid + '/' + getExpertVideos[3].title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()" class="nounderline">
                                        <img class="jw-img" :src="getExpertVideos[3].image"  :alt="getExpertVideos[3].title" :title="getExpertVideos[3].title" />
                                            <p class="text-wrap-title cursor"  v-if="getExpertVideos[3].marketing"> <i aria-hidden="true" class="fa fa-play-circle-o"></i><strong>{{getExpertVideos[3].title}}</strong></p>
                                            <p class="text-wrap-title cursor"  v-if="!getExpertVideos[3].marketing"> <i aria-hidden="true" class="fa fa-play-circle-o"></i>{{getExpertVideos[3].title}}</p>
                                </a>
                                <hr v-if="user && !getExpertVideos[3].marketing">
                                <div class="plusicon btn-group" v-if="user && !getExpertVideos[3].marketing">
                                    <button aria-label="Add video to a playlist" title="Add to Playlist" :id="getExpertVideos[3].mediaid" type="button" @click="showPlaylistMenu(getExpertVideos[3].mediaid)" class="dropdown-toggle ellipsis pull-right">
<!--                                        <img src="../assets/playlist-icon.png" class="menuiconbutton" alt="PLAYLIST" title="Playlist"/>-->
                                        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                             width="37px" height="24px" viewBox="0 0 37 24" enable-background="new 0 0 37 24" xml:space="preserve">
<rect y="0.2" :fill="getCorpHeaderColor" width="25" height="3"/>
                                            <rect y="8.2" :fill="getCorpHeaderColor" width="25" height="3"/>
                                            <rect y="17.2" :fill="getCorpHeaderColor" width="18.2" height="3"/>
                                            <rect x="23" y="15.2" :fill="getCorpHeaderColor" width="14" height="4"/>
                                            <rect x="27.958" y="10.242" :fill="getCorpHeaderColor" width="4" height="13.917"/>
</svg>
                                    </button>
                                    <ul class="hide">
                                        <li  v-if="getUserPlaylists">
                                            <label>
                                                <b> Add to ...</b>
                                            </label>
                                        </li>
                                        <li role="separator" class="divider"  v-if="getUserPlaylists"></li>
                                        <li  v-if="getUserPlaylists" v-for="playlist in getUserPlaylists">
                                            <label class="notificationwithcheckboxes">
                                                <input type="checkbox" :checked="verifyVideoExists(playlist, getExpertVideos[3])" @click="setPlaylistVideoStatus(getExpertVideos[3], playlist, verifyVideoExists(playlist, getExpertVideos[3])) "/> {{playlist.title}}
                                                <transition name="fade">
                                                    <!--<h6 v-if="video.mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoAdded">Added</h6>-->
                                                    <span class="added" v-if="getExpertVideos[3].mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoAdded">Added</span>
                                                </transition>
                                                <transition name="fade">
                                                    <span class="removed" v-if="getExpertVideos[3].mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoRemoved">Removed</span>
                                                </transition>
                                            </label>
                                        </li>
                                        <!--<li>-->
                                        <!--<label>-->
                                        <!--<input type="checkbox" /> Second option-->
                                        <!--</label>-->
                                        <!--</li>-->
                                        <!--<li>-->
                                        <!--<label>-->
                                        <!--<input type="checkbox" /> Third option-->
                                        <!--</label>-->
                                        <!--</li>-->
                                        <!--<li>-->
                                        <!--<label>-->
                                        <!--<input type="checkbox" /> Forth option-->
                                        <!--</label>-->
                                        <!--</li>-->
                                        <li role="separator" class="divider" v-if="getUserPlaylists"></li>
                                        <li><label style="color:#f0617d">Create new playlist</label></li>
                                        <li><label>  <input aria-label="New playlist name" type="text" class="form-control" v-model="newPlaylistName" />
                                            <i v-a11y-action aria-label="Insert New Playlist" class="fa fa-plus-circle" @click="addNewPlayList" title="Insert New Playlist"></i>

                                        </label> </li>
                                    </ul>
                                    <div class="backdropformenu"  @click="hidePlaylistMenu(getExpertVideos[5].mediaid)"></div>
                                </div>
                                <p class="right-heart-icon" v-if="user && !getExpertVideos[3].marketing">
                                    <a v-a11y-action aria-label="Liked this video?" href="javascript:" @click="setVideoStatus(getExpertVideos[3])" title ="Liked this video?">
                                        <i class="fa fa-2x fa-heart-o" v-bind:style="{ color: getCorpHeaderColor}"
                                           v-bind:class="{'activeIcons': getVideoStatus(getExpertVideos[3])}" aria-hidden="true" ></i></a>
                                </p>

                            </div>
                            <div class="col-xs-12 col-sm-6 col-md-4 bottom-margin" :class="{'innerimggray': getTrialDays < 0}"  v-if="getExpertVideos[6]">
                                <a :href="'/watch/' + getExpertVideos[6].mediaid + '/' + getExpertVideos[6].title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()" class="nounderline">
                                        <img class="jw-img" :src="getExpertVideos[6].image"  :alt="getExpertVideos[6].title" :title="getExpertVideos[6].title"/>
                                            <p class="text-wrap-title cursor"   v-if="getExpertVideos[6].marketing"> <i aria-hidden="true" class="fa fa-play-circle-o"></i><strong>{{getExpertVideos[6].title}}</strong></p>
                                            <p class="text-wrap-title cursor"  v-if="!getExpertVideos[6].marketing"> <i aria-hidden="true" class="fa fa-play-circle-o"></i>{{getExpertVideos[6].title}}</p>
                                </a>
                                <hr v-if="user && !getExpertVideos[6].marketing">
                                <div class="plusicon btn-group" v-if="user && !getExpertVideos[6].marketing">
                                    <button aria-label="Add video to a playlist" title="Add to Playlist" :id="getExpertVideos[6].mediaid" type="button" @click="showPlaylistMenu(getExpertVideos[6].mediaid)" class="dropdown-toggle ellipsis pull-right">
<!--                                        <img src="../assets/playlist-icon.png" class="menuiconbutton" alt="PLAYLIST" title="Playlist"/>-->
                                        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                             width="37px" height="24px" viewBox="0 0 37 24" enable-background="new 0 0 37 24" xml:space="preserve">
<rect y="0.2" :fill="getCorpHeaderColor" width="25" height="3"/>
                                            <rect y="8.2" :fill="getCorpHeaderColor" width="25" height="3"/>
                                            <rect y="17.2" :fill="getCorpHeaderColor" width="18.2" height="3"/>
                                            <rect x="23" y="15.2" :fill="getCorpHeaderColor" width="14" height="4"/>
                                            <rect x="27.958" y="10.242" :fill="getCorpHeaderColor" width="4" height="13.917"/>
</svg>
                                    </button>
                                    <ul class="hide">
                                        <li  v-if="getUserPlaylists">
                                            <label>
                                                <b> Add to ...</b>
                                            </label>
                                        </li>
                                        <li role="separator" class="divider"  v-if="getUserPlaylists"></li>
                                        <li  v-if="getUserPlaylists" v-for="playlist in getUserPlaylists">
                                            <label class="notificationwithcheckboxes">
                                                <input type="checkbox" :checked="verifyVideoExists(playlist, getExpertVideos[6])" @click="setPlaylistVideoStatus(getExpertVideos[6], playlist, verifyVideoExists(playlist, getExpertVideos[6])) "/> {{playlist.title}}
                                                <transition name="fade">
                                                    <!--<h6 v-if="video.mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoAdded">Added</h6>-->
                                                    <span class="added" v-if="getExpertVideos[6].mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoAdded">Added</span>
                                                </transition>
                                                <transition name="fade">
                                                    <span class="removed" v-if="getExpertVideos[6].mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoRemoved">Removed</span>
                                                </transition>
                                            </label>
                                        </li>
                                        <!--<li>-->
                                        <!--<label>-->
                                        <!--<input type="checkbox" /> Second option-->
                                        <!--</label>-->
                                        <!--</li>-->
                                        <!--<li>-->
                                        <!--<label>-->
                                        <!--<input type="checkbox" /> Third option-->
                                        <!--</label>-->
                                        <!--</li>-->
                                        <!--<li>-->
                                        <!--<label>-->
                                        <!--<input type="checkbox" /> Forth option-->
                                        <!--</label>-->
                                        <!--</li>-->
                                        <li role="separator" class="divider" v-if="getUserPlaylists"></li>
                                        <li><label style="color:#f0617d">Create new playlist</label></li>
                                        <li><label>  <input aria-label="New playlist name" type="text" class="form-control" v-model="newPlaylistName" />
                                            <i v-a11y-action aria-label="Insert New Playlist" class="fa fa-plus-circle" @click="addNewPlayList" title="Insert New Playlist"></i>

                                        </label> </li>
                                    </ul>
                                    <div class="backdropformenu"  @click="hidePlaylistMenu(getExpertVideos[6].mediaid)"></div>
                                </div>
                                <p class="right-heart-icon" v-if="user && !getExpertVideos[6].marketing">
                                    <a v-a11y-action aria-label="Liked this video?" href="javascript:" @click="setVideoStatus(getExpertVideos[6])" title ="Liked this video?">
                                        <i class="fa fa-2x fa-heart-o" v-bind:style="{ color: getCorpHeaderColor}"
                                           v-bind:class="{'activeIcons': getVideoStatus(getExpertVideos[6])}" aria-hidden="true" ></i></a>
                                </p>
                            </div>
                        </div>
                        <!--<div class="row">-->
                            <!--<div class="col-md-12 margin-bottom-40">-->
                                <!--<button class="btn btn-info btn-load-more btn-transparent btn-lg">Load More</button>-->
                            <!--</div>-->
                        <!--</div>-->
                    </div>
                </div>
            </div>
        </div>
        <!--<div v-if="getVideosFlag">-->
            <!--<h2 v-if="getExpert[0]" class="pinkh2">Videos from {{getExpert[0].name}} are coming soon!</h2>-->
        <!--</div>-->
        <div class="pintlist-holder" v-if="!getVideosFlag">
        <h2 v-if="expertInfo" class="pinkh2" v-bind:style="{ color: $a11yInkColor(getCorpHeadingColor) + ' !important' } ">browse all of {{expertInfo.name}}'s videos</h2>
            <div class="container">
                <div class="tabContent" id="tabs-1" :class="{ current: true }">
                    <div class="">
                        <div class="row yourFaves" v-if="getExpertPlaylist">
                            <div class="col-md-12">
                            </div>
                            <div class="col-xs-12 col-sm-6 col-md-4 bottom-margin" :class="{'innerimggray': getTrialDays < 0}" v-for = "video in getExpertPlaylist" v-if="!verifyVideoStatus(video.mediaid)">
                                <a :href="'/watch/' + video.mediaid + '/' + video.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()" class="nounderline">
                                <img class="jw-img" :src="video.image"  :alt="video.title" :title="video.title"/>
                                <p class="text-wrap-title cursor" > <i aria-hidden="true" class="fa fa-play-circle-o"></i> {{video.title}}</p>
                                </a>
                                <hr v-if="user">
                                <div class="plusicon btn-group" v-if="user">
                                    <button aria-label="Add video to a playlist" title="Add to Playlist" :id="video.mediaid" type="button" @click="showPlaylistMenu(video.mediaid)" class="dropdown-toggle ellipsis pull-right">
<!--                                        <img src="../assets/playlist-icon.png" class="menuiconbutton" alt="PLAYLIST" title="Playlist"/>-->
                                        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                             width="37px" height="24px" viewBox="0 0 37 24" enable-background="new 0 0 37 24" xml:space="preserve">
<rect y="0.2" :fill="getCorpHeaderColor" width="25" height="3"/>
                                            <rect y="8.2" :fill="getCorpHeaderColor" width="25" height="3"/>
                                            <rect y="17.2" :fill="getCorpHeaderColor" width="18.2" height="3"/>
                                            <rect x="23" y="15.2" :fill="getCorpHeaderColor" width="14" height="4"/>
                                            <rect x="27.958" y="10.242" :fill="getCorpHeaderColor" width="4" height="13.917"/>
</svg>
                                    </button>
                                    <ul class="hide">
                                        <li  v-if="getUserPlaylists">
                                            <label>
                                                <b> Add to ...</b>
                                            </label>
                                        </li>
                                        <li role="separator" class="divider"  v-if="getUserPlaylists"></li>
                                        <li  v-if="getUserPlaylists" v-for="playlist in getUserPlaylists">
                                            <label class="notificationwithcheckboxes">
                                                <input type="checkbox" :checked="verifyVideoExists(playlist, video)" @click="setPlaylistVideoStatus(video, playlist, verifyVideoExists(playlist, video)) "/> {{playlist.title}}
                                                <transition name="fade">
                                                    <!--<h6 v-if="video.mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoAdded">Added</h6>-->
                                                    <span class="added" v-if="video.mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoAdded">Added</span>
                                                </transition>
                                                <transition name="fade">
                                                    <span class="removed" v-if="video.mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoRemoved">Removed</span>
                                                </transition>
                                            </label>
                                        </li>
                                        <!--<li>-->
                                        <!--<label>-->
                                        <!--<input type="checkbox" /> Second option-->
                                        <!--</label>-->
                                        <!--</li>-->
                                        <!--<li>-->
                                        <!--<label>-->
                                        <!--<input type="checkbox" /> Third option-->
                                        <!--</label>-->
                                        <!--</li>-->
                                        <!--<li>-->
                                        <!--<label>-->
                                        <!--<input type="checkbox" /> Forth option-->
                                        <!--</label>-->
                                        <!--</li>-->
                                        <li role="separator" class="divider" v-if="getUserPlaylists"></li>
                                        <li><label style="color:#f0617d">Create new playlist</label></li>
                                        <li><label>  <input aria-label="New playlist name" type="text" class="form-control" v-model="newPlaylistName" />
                                            <i v-a11y-action aria-label="Insert New Playlist" class="fa fa-plus-circle" @click="addNewPlayList" title="Insert New Playlist"></i>

                                        </label> </li>
                                    </ul>
                                    <div class="backdropformenu"  @click="hidePlaylistMenu(video.mediaid)"></div>
                                </div>
                                <p class="right-heart-icon" v-if="user">
                                    <a v-a11y-action aria-label="Liked this video?" href="javascript:" @click="setVideoStatus(video)" title ="Liked this video?">
                                        <i class="fa fa-2x fa-heart-o" v-bind:style="{ color: getCorpHeaderColor}"
                                           v-bind:class="{'activeIcons': getVideoStatus(video)}" aria-hidden="true" ></i></a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            <!--<div class="row">-->
                <!--<div class="col-sm-offset-2 col-sm-8">-->
                    <!--<ul class="pink_container" v-if="getExpertPlaylist">-->
                        <!--<li v-for="item in getExpertPlaylist">{{item.title}}</li>-->
                    <!--</ul>-->
                <!--</div>-->
            <!--</div>-->
            </div>

        </div>
        <div class="pintlist-holder" v-if="expertInfo && getExpertArchiveClips && user">
            <h2 v-if="expertInfo" class="pinkh2" v-bind:style="{ color: $a11yInkColor(getCorpHeadingColor) + ' !important' } ">TONE Coaching Tips</h2><br>
            <div class="container">
                <div class="tabContent" id="tabs-5" :class="{ current: true }">
                    <div class="">
                        <div class="row yourFaves" v-if="getExpertArchiveClips">
                        <div class="col-xs-12 col-sm-6 col-md-4 bottom-margin" :class="{'innerimggray': getTrialDays < 0}" v-for="evn in getExpertArchiveClips" style="cursor: pointer">
                            <div class="show-share-options"><img v-a11y-action :aria-label="evn.title" class="jw-img" v-bind:src="evn.img_url" @click="playVideoArchive(evn.eventId, evn.title)" alt="ARCHIVE EVENT BANNER" :title="evn.title" /><div class="favnumbers" v-bind:style="{ backgroundColor: getCorpHeaderColor}"><div><span>{{evn.allVidDurInMinutes}}<small>mins</small></span></div><i v-a11y-action aria-label="Play" title="Play" class="fa fa-play-circle-o" @click="playVideoArchive(evn.eventId, evn.title)"></i><i v-a11y-action aria-label="Share Playlist" v-if="((user && user.corporation === null) || (user && user.corporation && user.corporation.corpSharingPermissions && user.corporation.corpSharingPermissions.shareExpertCoachingTipPermission >= 1))" title="Share Playlist" class="fa fa-share-square-o" @click="showSharingModal(evn)"></i></div></div>
                            <h2><button type="button" class="tone-heading-button" @click="playVideoArchive(evn.eventId, evn.title)">{{evn.title}}</button></h2>
                            <p v-a11y-action @click="playVideoArchive(evn.eventId, evn.title)">
                                {{evn.longDescription}}

                            </p>
                            <!--<button class="button" type="button" @click="playVideoArchive(evn.eventId, evn.title)"><i class="fa 2x fa-play-circle-o" aria-hidden="true"></i>&nbsp;Play&nbsp;</button>-->
                            <!--<h5>{{getDateReference(evn.start_date, 'live2')}}</h5>-->
                            <!--time left in event {{timeLeftInEvent(evn.start_date)}}-->
                            <!--<span>72 Members | 302 Comments</span>-->
                            <!--<button class="button" v-if="!isUserEntrolled(evn.eventId) && isEventToday(evn.start_date, evn.end_date) === false" @click="enrollUser(evn)" type="button">Reserve your spot</button>-->
                            <!--<button  class="btn btn-danger expert-section-btn btn-transparent">Reserve a Seat at the Table</button>-->
                            <!--<button type="button" class="btn disabled">Coming Soon</button>-->
                        </div>
                        </div>
                    </div>
                </div>
                <!--<div class="row">-->
                <!--<div class="col-sm-offset-2 col-sm-8">-->
                <!--<ul class="pink_container" v-if="getExpertPlaylist">-->
                <!--<li v-for="item in getExpertPlaylist">{{item.title}}</li>-->
                <!--</ul>-->
                <!--</div>-->
                <!--</div>-->
            </div>

        </div>

        <modal v-if="showWatchVideoModal" class="watchVideoModal" effect="zoom" :value="showWatchVideoModal" @cancel="cancelModal()">
            <div slot="modal-header" class="watchVideoModalHeader">
                <a>
                    <img src="../assets/logo.svg" alt="LOGO">
                </a>
                <a v-a11y-action href="javascript:" @click="cancelModal()">
                    <img class="watchVideoArrow" src="../assets/watch-video-arrow.png" alt="CLOSE">
                </a>
            </div>
            <div slot="modal-body" class="modal-body">
                <jwplayer :data="currentPlayerID">Loading the player...</jwplayer>
                <p>
                    {{currentPlayerID.videoDescription}}
                </p>
            </div>
            <div slot="modal-footer"></div>
        </modal>
        <modal v-if="showSharedModal" class="watchVideoModal" effect="zoom" :value="showSharedModal" @cancel="cancelEmailShareModal()">
            <div slot="modal-header" class="watchVideoModalHeader">
                <a>
                    <img src="../assets/logo.svg" alt="LOGO">
                </a>
                <a v-a11y-action href="javascript:" @click="cancelEmailShareModal()">
                    <img class="watchVideoArrow" src="../assets/watch-video-arrow.png" alt="CLOSE">
                </a>
            </div>
            <div slot="modal-body" class="modal-body">
                <div class="form">
                    <form method="post" id="playlistshare-form" v-on:submit.prevent="onSharePlaylist" autocomplete="off">
                        <multiselect aria-label="Email recipients" v-model="taggedEmails" style="padding-bottom: 10px;"
                                     tag-placeholder="Add this as new email address"
                                     placeholder="Search or add an email address"
                                     label="name"
                                     track-by="name"
                                     :options="emailList"
                                     :multiple="true"
                                     :taggable="true"
                                     @tag="addTag"></multiselect>
                        <bs-input label="Optional Message" v-model="sharePayload.sharedEmailMessage"
                                  name="playlistshare_sharedMessage"
                                  id = "playlistshare_sharedMessage"
                                  type="text"
                                  class="form-input"
                                  error="Optional Message"
                                  placeholder="Optional Message"
                                  autocomplete="off"
                                  icon>
                        </bs-input>
                        <bs-input label="Email preview" v-model="sharePayload.sharedPlaylistPreview"
                                  name="playlistshare_sharedEmailMessagePreview"
                                  id="playlistshare_sharedEmailMessagePreview"
                                  type="textarea"
                                  disabled
                                  class="form-input"
                                  placeholder=""
                        >
                        </bs-input>
                        <button type="submit"  class="btn formButton btn-block" :disabled="spinner || (taggedEmails && taggedEmails.length === 0)">
                            Send Email
                            <spinner v-model="spinner" size="lg" class="btn-spinner"></spinner>
                        </button>
                    </form>
                </div>
            </div>
            <div slot="modal-footer">
            </div>
        </modal>
        <modal v-if="showCorporateShare" class="watchVideoModal sharesmallpink" effect="zoom" :value="showCorporateShare" @cancel="cancelCorporateModal()">
            <div slot="modal-header" class="watchVideoModalHeader" v-bind:style="{ backgroundColor: getCorpHeaderColor}">
                <i aria-hidden="true" class="fa fa-share-square-o"></i> Share with your Corporate Community Or Friends
                <a v-a11y-action href="javascript:" @click="cancelCorporateModal()">
                    <img class="watchVideoArrow" src="../assets/watch-video-arrow.png" alt="CLOSE">
                </a>
            </div>
            <div slot="modal-body" class="modal-body">
                <div class="row">
                    <div class="col-sm-4">
                        <select aria-label="Share with" v-model="shareOption" class="form-control strongselec">
                            <option value="Corporate" v-if="showShareCommunity">Share with Community</option>
                            <option value="Individual" v-if="showShareIndividual">Share with Colleagues</option>
                            <option value="Friends" v-if="showShareFriends">Share with Friends</option>
                        </select>
                    </div>
                    <div class="col-sm-12"  v-if="shareOption === 'Individual'">
                        <div class="clearfix" style="height: 20px;"></div>
                        <multiselect aria-label="Corporate recipients" v-if="shareOption === 'Individual'"
                                     v-model="selectedCorps"
                                     :options="allCorps"
                                     :multiple="true"
                                     :taggable="true"
                                     track-by="userId"
                                     :custom-label="customLabel">
                        </multiselect>
                    </div>
                    <div class="col-sm-12"  v-if="shareOption === 'Friends'">
                        <div class="clearfix" style="height: 20px;"></div>
                        <multiselect aria-label="Email recipients" v-model="taggedEmails" style="padding-bottom: 10px;"
                                     tag-placeholder="Add this as new email address"
                                     placeholder="Search or add an email address"
                                     label="name"
                                     track-by="name"
                                     :options="emailList"
                                     :multiple="true"
                                     :taggable="true"
                                     @tag="addTag"></multiselect>
                    </div>
                </div>
                <hr>
                <div class="usernamenimg text-left">
                    <table>
                        <tr>
                            <td>
                                <img v-bind:src="user && user.corporation && user.corporation.showShoeMotif === 2 ? 'https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png' : user.picture" alt="user">&nbsp;&nbsp; <b>{{user.firstName.toLowerCase()}}</b>
                            </td>
                            <!--                            <td>-->
                            <!--                                <b>{{user.firstName.toLowerCase()}}</b>-->
                            <!--                            </td>-->
                        </tr>
                    </table>
                </div>
                <div class="clearfix"></div>
                <div class="clearfix"></div>
                <div class="clearfix"></div>
                <textarea aria-label="Type your message" v-model="corporateShareMessage"
                          type="textarea"
                          class="form-input form-control"
                          placeholder="Type your message"
                />
                <div class="clearfix" style="height: 30px;"></div>
                <div class="row sharefb">
                    <div class="col-sm-5 col-xs-5">
                        <img :src="corpShareModalImage" :alt="corpShareModalTitle" :title="corpShareModalTitle">
                    </div>
                    <div class="col-sm-7 col-xs-7">
                        <h6>WWW.TONENETWORKS.COM</h6>
                        <h4>{{`${corpShareModalTitle} | TONE Networks`}}</h4>
                        <p v-if="corpShareModalDesc"> {{`${corpShareModalDesc.substring(0,250)}...`}}</p>
                        <p v-if="!corpShareModalDesc">{{user.firstName}}'s Personal Playlist</p>
                    </div>
                </div>
                <div class="clearfix"></div>
                <div class="row buttonsinpopup">
                    <div class="col-sm-3 col-xs-4">
                        <button class="btn btn-default" @click="cancelCorporateModal()">
                            Cancel
                        </button>
                    </div>
                    <div class="col-sm-9 col-xs-8">
                        <button   v-bind:style="{ color: $a11yTextColor(getCorpButtonColor) + ' !important',  backgroundColor: getCorpButtonColor, borderWidth: '1px !important', borderStyle: 'solid !important', borderColor: this.getCorpButtonColor + ' !important'}" class="btn btn-primary btn-pink" :disabled="(shareOption === 'Individual' && (selectedCorps === null || selectedCorps.length === 0 || shareInProcess)) || (shareOption === 'Friends' && (taggedEmails === null || taggedEmails.length === 0 || shareInProcess)) " @click="shareCorporateVideo()">
                            Share This Playlist
                            <spinner v-model="shareInProcess" size="lg" class="btn-spinner"></spinner>
                        </button>
                    </div>
                </div>
                <div class="alert alert-default showmobile">
                    You are sharing as {{`${user.firstName} ${user.lastName}`}}
                </div>
            </div>
            <div slot="modal-footer"></div>
        </modal>
        <modal v-if="showCorporateImageShare" class="watchVideoModal sharesmallpink" effect="zoom" :value="showCorporateImageShare" @cancel="cancelCorporateImageModal()">
            <div slot="modal-header" class="watchVideoModalHeader" v-bind:style="{ backgroundColor: getCorpHeaderColor}">
                <i aria-hidden="true" class="fa fa-share-square-o"></i> Share with your Corporate Community Or Friends
                <a v-a11y-action href="javascript:" @click="cancelCorporateImageModal()">
                    <img class="watchVideoArrow" src="../assets/watch-video-arrow.png" alt="CLOSE">
                </a>
            </div>
            <div slot="modal-body" class="modal-body">
                <div class="row">
                    <div class="col-sm-4">
                        <select aria-label="Share with" v-model="shareOption" class="form-control strongselec">
                            <option value="Corporate">Share with Community</option>
                            <option value="Individual">Share with Colleagues</option>
                            <option value="Friends">Share with Friends</option>
                        </select>
                    </div>
                    <div class="col-sm-12"  v-if="shareOption === 'Individual'">
                        <div class="clearfix" style="height: 20px;"></div>
                        <multiselect aria-label="Corporate recipients" v-if="shareOption === 'Individual'"
                                     v-model="selectedCorps"
                                     :options="allCorps"
                                     :multiple="true"
                                     :taggable="true"
                                     track-by="userId"
                                     :custom-label="customLabel">
                        </multiselect>
                    </div>
                    <div class="col-sm-12"  v-if="shareOption === 'Friends'">
                        <div class="clearfix" style="height: 20px;"></div>
                        <multiselect aria-label="Email recipients" v-model="taggedEmails" style="padding-bottom: 10px;"
                                     tag-placeholder="Add this as new email address"
                                     placeholder="Search or add an email address"
                                     label="name"
                                     track-by="name"
                                     :options="emailList"
                                     :multiple="true"
                                     :taggable="true"
                                     @tag="addTag"></multiselect>
                    </div>
                </div>
                <hr>
                <div class="usernamenimg text-left">
                    <table>
                        <tr>
                            <td>
                                <img v-bind:src="user && user.corporation && user.corporation.showShoeMotif === 2 ? 'https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png' : user.picture" alt="user">&nbsp;&nbsp; <b>{{user.firstName.toLowerCase()}}</b>
                            </td>
                            <!--                            <td>-->
                            <!--                                <b>{{user.firstName.toLowerCase()}}</b>-->
                            <!--                            </td>-->
                        </tr>
                    </table>
                </div>
                <div class="clearfix"></div>
                <div class="clearfix"></div>
                <div class="clearfix"></div>
                <textarea aria-label="Type your message" v-model="corporateShareMessage"
                          type="textarea"
                          class="form-input form-control"
                          placeholder="Type your message"
                />
                <div class="clearfix" style="height: 30px;"></div>
                <div class="row sharefb">
                    <div class="col-sm-5 col-xs-5">
                        <img :src="shareEventSelected.img_url" :alt="shareEventSelected.title" :title="shareEventSelected.title">
                    </div>
                    <div class="col-sm-7 col-xs-7">
                        <h6>WWW.TONENETWORKS.COM</h6>
                        <h4>{{`${shareEventSelected.title} | TONE Networks`}}</h4>
                        <p> {{`${shareEventSelected.longDescription.substring(0,250)}...`}}</p>
                    </div>
                </div>
                <div class="clearfix"></div>
                <div class="row buttonsinpopup">
                    <div class="col-sm-3 col-xs-4">
                        <button class="btn btn-default" @click="cancelCorporateImageModal()">
                            Cancel
                        </button>
                    </div>
                    <div class="col-sm-9 col-xs-8">
                        <button v-bind:style="{ color: $a11yTextColor(getCorpButtonColor) + ' !important',  backgroundColor: getCorpButtonColor, borderWidth: '1px !important', borderStyle: 'solid !important', borderColor: this.getCorpButtonColor + ' !important'}" class="btn btn-primary btn-pink" :disabled="(shareOption === 'Individual' && (selectedCorps === null || selectedCorps.length === 0 || shareInProcess)) || (shareOption === 'Friends' && (taggedEmails === null || taggedEmails.length === 0 || shareInProcess)) " @click="shareCorporateImage()">
                            Share This Event
                            <spinner v-model="shareInProcess" size="lg" class="btn-spinner"></spinner>
                        </button>
                    </div>
                </div>
                <div class="alert alert-default showmobile">
                    You are sharing as {{`${user.firstName} ${user.lastName}`}}
                </div>
            </div>
            <div slot="modal-footer"></div>
        </modal>
    </div>
</template>

<script>
    import jwplayer from './JwPlayer.vue'
    import JwPlayList from './JwPlayList.vue'
    import slick from 'slick-carousel'
    import { tab } from 'vue-strap'
    import tabs from '@/accessibility/Tabs'
    import spinner from '@/accessibility/Spinner'
    import modal from '@/accessibility/Modal'
    import input from '@/accessibility/Input'
    import {mapGetters} from 'vuex'
    import $ from 'jquery'
    import rulescomp from './RulesComp.vue'
//    import store from '../store'
    import { dateHelpers } from '../helpers/dateHelpers.js'
    export default {
        name: 'expert',
        components: {
            jwplayer,
            'jwplaylist': JwPlayList,
            'tabs': tabs,
            'bs-input': input,
            spinner,
            'tab': tab,
            modal: modal,
            rulescomp
        },
        metaInfo () {
            let self = this
            return {
                title: self.expertTitle,
                meta: [
                    {property: 'og:image', content: self.expertImage},
                    {property: 'og:title', content: self.expertTitle},
                    {property: 'og:site_name', content: 'TONE Networks | Expert Advice on Demand'},
                    {
                        property: 'og:description',
                        content: self.expertBio
                    },
                    {property: 'twitter:title', content: self.expertTitle},
                    {property: 'twitter:card', content: 'summary'},
                    {property: 'twitter:image', content: self.expertImage},
                    {
                        property: 'twitter:description',
                        content: self.expertBio
                    },
                    {property: 'og:image:width', content: '300'},
                    {property: 'og:image:height', content: '300'}
                ]
            }
        },
        data: function () {
            return {
                shareImagePayload: {
                    corporationId: 0,
                    senderUserId: 0,
                    recipientsUserIds: [],
                    recipientFriendEmails: null,
                    eventId: '',
                    customizedMessage: '',
                    playlistType: 6
                },
                shareEventSelected: null,
                showCorporateImageShare: false,
                corporateShareMessage: '',
                selectedPlaylist: null,
                corpShareModalImage: '',
                showCorporateShare: false,
                corpShareModalTitle: '',
                corpShareModalDesc: '',
                selectedCorps: [],
                allCorps: [],
                shareOption: 'Corporate',
                showShareCommunity: false,
                showShareIndividual: false,
                showShareFriends: false,
                sharePlaylistType: '',
                archiveEventId: 0,
                archiveEventTitle: '',
                spinner: false,
                taggedEmails: [],
                emailList: [],
                previewMsg: 'Message Preview: \n',
                showSharedModal: false,
                shareInProcess: false,
                toggleSpinner: false,
                expertInfo: null,
                activeTab: 0,
                expertEvent: '',
                expertMainVideo: '',
                showWatchVideoModal: false,
                currentPlayerID: '',
                currentVideoRef: '',
                newPlaylistName: '',
                videoAdded: false,
                videoRemoved: false,
                selectedVideo: 0,
                selecedPlaylist: 0,
                topVideos: [],
                expertTitle: '',
                expertImage: '',
                expertBio: '',
                eventURL: 'https://www1.dev-tonenetworks.com',
                seatReservation: {
                    userEventId: 0,
                    eventId: 0,
                    userId: 0,
                    status: 0,
                    isAnonymous: 0
                },
                sharePayload: {
                    tmpVideCode: '',
                    sharedEmailList: '',
                    sharedEmailMessage: '',
                    sharedPlaylistPreview: ''
                },
                shareVideoPayload: {
                    corporationId: 0,
                    senderUserId: 0,
                    recipientsUserIds: [],
                    recipientFriendEmails: null,
                    playlistId: '',
                    messageText: '',
                    playlistType: 4
                }
            }
        },
        mounted: function () {
            setTimeout(function () {
                window.addeventatc.refresh()
            }, 2000)
//            this.store.commit('setExpert', {expert: null})
//            this.store.commit('setExpertVideos', {expertVideos: null})
//            // Get Expert Information
            let self = this
            if (self.user) {
                self.$store.dispatch('GET_EXPERT_EVENT_CLIPS', self.$route.params.expertId).then(() => {
                    if (self.getExpertArchiveClips) {
                        console.log('archive clips', self.getExpertArchiveClips)
                    }
                })
            }
            self.$store.dispatch('GET_EXPERT_BY_BY_ID', self.$route.params.expertId).then(() => {
                if (self.getExpert) {
                    self.expertInfo = self.getExpert[0]
                    if (self.expertInfo.experties) {
                        this.expertTitle = `TONE Expert | ${self.expertInfo.name}, ${self.expertInfo.experties}`
                    } else {
                        this.expertTitle = `TONE Expert | ${self.expertInfo.name}`
                    }
                    this.expertImage = self.expertInfo.large_image
                    this.expertBio = self.expertInfo.areasofexpertise
                    // Get Event List
                    this.$store.dispatch('GET_EXPERT_NEXT_EVENT', self.$route.params.expertId).then(() => {
                        if (self.getExpertNextEvent) {
                            console.log('expert next event', self.getExpertNextEvent)
                            self.expertEvent = self.getExpertNextEvent
                        } else {
                            self.expertEvent = null
                        }
                    })
                    self.$store.dispatch('CACHEPAGE', window.location.href)
                    // Get User Events
                    if (self.user) {
                        self.$store.dispatch('GETUSEREVENTS', self.user.userId).then(() => {
                        })
                    }
                } else {
                    self.$swal({
                        title: `Expert not found!`,
                        text: '',
                        type: 'error',
                        timer: 2000,
                        showCancelButton: false,
                        showConfirmButton: false
                    }).then(
                        function () {
                        },
                        // handling the promise rejection
                        function (dismiss) {
                            if (dismiss === 'timer') {
                                self.$router.push('/experts')
                            }
                        }
                    )
                }
               // console.log('expert', this.getExpert)
            })
            // Get Tagged Email List
            if (self.user) {
                self.$store.dispatch('GET_TAGGED_EMAIL_LIST', self.user.userId).then(() => {
                    if (self.getTaggedEmailList) {
                        self.emailList = []
                        self.emailList = self.getTaggedEmailList
                        console.log('email list', self.getTaggedEmailList)
                    }
                })
                // Get Corporation Users
                this.$store.dispatch('GETCORPPAYLOAD', this.user.userId).then(() => {
                    this.allCorps = []
                    if (this.getCorporatePayload) {
                        this.corporateInfo = this.getCorporatePayload
                        this.allCorps = this.corporateInfo.lstCorporationUsers
                    }
                })
            }
            // Get Expert Videos
            let corpId = 0
            if (self.user && this.user.corporation && self.user.corporation.corporationId > 0) {
                corpId = self.user.corporation.corporationId
            }
            let params = [self.$route.params.expertId, corpId]
            this.$store.dispatch('GETEXPERTVIDEOS', params).then(() => {
                if (self.getExpertVideos) {
                    self.topVideos = self.getExpertVideos.slice(0, 7)
                    console.log('top videos retreived', self.topVideos)
                    console.log('after status', self.getExpertVideos)
                    let mainVideo = this.getExpertVideos[0]
                    if (!this.expertEvent) {
                        this.expertMainVideo = {
                            video: mainVideo.sources[mainVideo.sources.length - 1].file,
                            title: mainVideo.title,
                            img: mainVideo.image,
                            playerID: new Date(),
                            tracks: mainVideo.tracks,
                            isMute: true,
                            showCaptions: true,
                            mediaId: mainVideo.mediaid
                        }
                    }
                }
            })
            self.$store.dispatch('GETEXPERTPLAYLIST', params).then(() => {
            })
            // Get User Liked Videos
            if (self.user) {
                this.$store.dispatch('GETAUTHUSERVIDEOS', self.user.userId).then(() => {
                    // this.charities = this.getAuthUserVideos
                })
            }
            // Get User Playlists
            if (self.user) {
                this.$store.dispatch('GETUSERPLAYLISTS', self.user.userId).then(() => {
                    // this.charities = this.getAuthUserVideos
                })
            }
            window.scrollTo(0, 0)
        },
        watch: {
            'sharePayload.sharedEmailMessage' (to, from) {
                let self = this
                let oriiginalMessage = `${self.user.firstName} shared a coaching tips playlist with you on Tone Networks: \n${self.archiveEventTitle} \n`
                if (self.showSharedModal && (self.sharePayload.sharedEmailMessage && self.sharePayload.sharedEmailMessage.length > 0)) {
                    self.sharePayload.sharedPlaylistPreview = `${self.previewMsg}${oriiginalMessage}${self.sharePayload.sharedEmailMessage}`
                } else {
                    self.sharePayload.sharedPlaylistPreview = `${self.previewMsg} ${self.user.firstName} shared a coaching tips playlist with you on Tone Networks: \n${self.archiveEventTitle} \n`
                }
            },
            'shareOption' (to, from) {
                let self = this
                self.selectedCorps = null
                self.corporateShareMessage = ''
                self.taggedEmails = []
            }
        },
        methods: {
            replaceLastExpert (strArray, chr, newChr) {
                var a = strArray.split('')
                a[strArray.lastIndexOf(chr)] = newChr
                return a.join('').replace('/,/g', ', ')
            },
            shareCorporateImage () {
                let self = this
                self.shareImagePayload.corporationId = self.shareOption === 'Corporate' ? 1 : 0
                self.shareImagePayload.senderUserId = self.user.userId
                self.shareImagePayload.recipientsUserIds = []
                self.shareImagePayload.recipientFriendEmails = null
                self.shareImagePayload.customizedMessage = self.corporateShareMessage
                if (self.shareOption === 'Corporate') {
                    self.shareImagePayload.recipientsUserIds = []
                    self.shareImagePayload.recipientFriendEmails = null
                } else if (self.shareOption === 'Individual') {
                    self.shareImagePayload.recipientFriendEmails = null
                    if (self.selectedCorps && self.selectedCorps.length > 0) {
                        self.shareImagePayload.recipientsUserIds = self.selectedCorps.map(x => {
                            return x.userId
                        })
                    }
                } else if (self.shareOption === 'Friends') {
                    self.shareImagePayload.recipientsUserIds = []
                    let emailArray = self.taggedEmails.map(x => {
                        return x.name
                    })
                    self.shareImagePayload.recipientFriendEmails = emailArray.join(',')
                } else {
                }
                self.shareImagePayload.eventId = self.shareEventSelected.eventId
                self.shareInProcess = true
                // Send the Email
                self.$store.dispatch('CORP_EVENT_SHARE', {payload: self.shareImagePayload}).then(() => {
                    if (!self.error.show) {
                        self.spinnerToggle()
                        self.$swal({
                            title: 'Event has been shared!',
                            text: '',
                            type: 'success',
                            timer: 3000,
                            showCancelButton: false,
                            showConfirmButton: false
                        }).then(
                            function () {
                            },
                            // handling the promise rejection
                            function (dismiss) {
                                if (dismiss === 'timer') {
                                }
                            }
                        )
                        // self.shareInProcess = false
                        // self.spinnerToggle()
                        self.cancelCorporateImageModal()
                    } else {
                        // self.shareInProcess = false
                        // self.spinnerToggle()
                        self.cancelCorporateImageModal()
                    }
                })
            },
            openCorporateImageShareModal (tEvent) {
                console.log('event for share', tEvent)
                let self = this
                self.shareInProcess = false
                self.shareEventSelected = tEvent
                self.corpShareModalImage = tEvent.img_url
                self.corpShareModalDesc = tEvent.description
                self.corpShareModalTitle = tEvent.title
                self.showCorporateImageShare = true
            },
            cancelCorporateImageModal () {
                $('html').removeClass('model-open')
                var self = this
                window.setTimeout(function () {
                    self.showCorporateImageShare = false
                    self.shareInProcess = false
                    $('.modal-open').removeClass('modal-open')
                }, 500)
            },
            shareCorporateVideo () {
                let self = this
                self.shareVideoPayload.corporationId = self.shareOption === 'Corporate' ? 1 : 0
                self.shareVideoPayload.senderUserId = self.user.userId
                self.shareVideoPayload.recipientsUserIds = []
                self.shareVideoPayload.recipientFriendEmails = null
                self.shareVideoPayload.messageText = self.corporateShareMessage
                if (self.shareOption === 'Corporate') {
                    self.shareVideoPayload.recipientsUserIds = []
                    self.shareVideoPayload.recipientFriendEmails = null
                } else if (self.shareOption === 'Individual') {
                    self.shareVideoPayload.recipientFriendEmails = null
                    if (self.selectedCorps && self.selectedCorps.length > 0) {
                        self.shareVideoPayload.recipientsUserIds = self.selectedCorps.map(x => {
                            return x.userId
                        })
                    }
                } else if (self.shareOption === 'Friends') {
                    self.shareVideoPayload.recipientsUserIds = []
                    let emailArray = self.taggedEmails.map(x => {
                        return x.name
                    })
                    self.shareVideoPayload.recipientFriendEmails = emailArray.join(',')
                } else {
                }
                self.shareVideoPayload.playlistId = self.archiveEventId
                // Send the Email
                if (!self.shareInProcess) {
                    self.$store.dispatch('PLAYLISTCORPORATESHARE', {payload: self.shareVideoPayload}).then(() => {
                        if (!self.error.show) {
                            self.spinnerToggle()
                            self.$swal({
                                title: 'Playlist has been shared!',
                                text: '',
                                type: 'success',
                                timer: 3000,
                                showCancelButton: false,
                                showConfirmButton: false
                            }).then(
                                function () {
                                },
                                // handling the promise rejection
                                function (dismiss) {
                                    if (dismiss === 'timer') {
                                    }
                                }
                            )
                            // self.spinnerToggle()
                            // self.shareInProcess = false
                            self.cancelCorporateModal()
                        } else {
                            // self.spinnerToggle()
                            // self.shareInProcess = false
                            self.cancelCorporateModal()
                        }
                    })
                }
                self.shareInProcess = true
            },
            maskEmailAddress (userEmail) {
                let avg, splitted, part1, part2
                splitted = userEmail.split('@')
                part1 = splitted[0]
                let regex = /[^0-9.]/g
                let maskid = part1.substring(0, 1) + part1.replace(regex, '*').substring(1)
                console.log('maked', maskid)
                avg = part1.length / 2
                part1 = part1.substring(0, (part1.length - avg))
                part2 = splitted[1]
                let maskDomain = part2.split('.')
                return maskid + '@' + maskDomain[0].replace(regex, '*') + '.' + maskDomain[maskDomain.length - 1]
            },
            customLabel (option) {
                let findDuplicate = this.allCorps.find(x => {
                    return x.firstName.toLowerCase() === option.firstName.toLowerCase() && x.lastName.toLowerCase() === option.lastName.toLowerCase() && x.userId !== option.userId
                })
//            console.log('findDuplicate', findDuplicate)
                if (findDuplicate) {
                    let maskedEmail = this.maskEmailAddress(option.email)
                    return `${option.firstName} ${option.lastName} <${maskedEmail}>`
                } else {
                    return `${option.firstName} ${option.lastName}`
                }
            },
            openCorporateShareModal (playlistObj) {
                let self = this
                self.shareInProcess = false
                self.corpShareModalImage = playlistObj.img_url
                self.corpShareModalDesc = playlistObj.description
                self.corpShareModalTitle = playlistObj.title
                self.selectedPlaylist = playlistObj
                self.archiveEventId = playlistObj.eventId
                self.showCorporateShare = true
                // Set up user rights
                if (self.user && self.user.corporation && self.user.corporation.corpSharingPermissions && self.user.corporation.corpSharingPermissions.shareExpertCoachingTipPermission >= 1) {
                    let rights = self.user.corporation.corpSharingPermissions.shareExpertCoachingTipPermission
                    console.log('rights', rights)
                    if (rights === 1) {
                        self.showShareCommunity = true
                        self.showShareIndividual = true
                        self.showShareFriends = true
                    } else if (rights === 2) {
                        self.showShareCommunity = true
                        self.showShareIndividual = false
                        self.showShareFriends = false
                        self.shareOption = 'Corporate'
                    } else if (rights === 3) {
                        self.showShareCommunity = false
                        self.showShareFriends = false
                        self.showShareIndividual = true
                        self.shareOption = 'Individual'
                    } else if (rights === 5) {
                        self.showShareCommunity = false
                        self.showShareIndividual = false
                        self.showShareFriends = true
                        self.shareOption = 'Friends'
                    } else {
                        self.showShareCommunity = false
                        self.showShareIndividual = false
                        self.showShareFriends = false
                    }
                }
            },
            showSharingModal (playlistObj) {
                console.log('playlist obj', playlistObj)
                let self = this
                if (self.user && self.user.corporation === null) {
                    self.openModalShare(playlistObj.eventId, playlistObj.title)
                } else {
                    self.openCorporateShareModal(playlistObj)
                }
            },
            verifyEmailShare (email) {
                if (email.length > 0) {
                    let re = /\S+@\S+\.\S+/
                    if (!re.test(email)) {
                        return false
                    } else {
                        return true
                    }
                } else {
                    return false
                }
            },
            addTag (newTag) {
                let self = this
                console.log('newTAg', newTag)
                const tag = {
                    name: newTag
                }
                if (self.verifyEmailShare(newTag)) {
                    self.emailList.push(tag)
                    this.taggedEmails.push(tag)
                    console.log('tagged emails', this.taggedEmails)
                } else {
                    console.log('invalid email address, calling swal')
                    // self.$swal({
                    //     title: 'Invalid Email Address',
                    //     text: 'Please enter valid email address',
                    //     type: 'error',
                    //     timer: 2000,
                    //     showCancelButton: false,
                    //     showConfirmButton: false
                    // }).then(
                    //     function () {
                    //     },
                    //     // handling the promise rejection
                    //     function (dismiss) {
                    //         if (dismiss === 'timer') {
                    //         }
                    //     }
                    // )
                }
            },
            cancelCorporateModal () {
                $('html').removeClass('model-open')
                var self = this
                window.setTimeout(function () {
                    self.showCorporateShare = false
                    self.shareInProcess = false
                    $('.modal-open').removeClass('modal-open')
                }, 500)
            },
            spinnerToggle () {
                this.spinner = !this.spinner
            },
            cancelEmailShareModal () {
                var self = this
                var $ = window.jQuery
                self.sharePayload.tmpVideCode = ''
                self.sharePayload.sharedEmailList = ''
                self.sharePayload.sharedEmailMessage = ''
                setTimeout(function () {
                    self.showSharedModal = false
                    self.archiveEventId = 0
                    self.archiveEventTitle = ''
                    self.sharePayload.sharedPlaylistPreview = ''
                    /* remove the class added by default by modal, when open to retain the scrolling behaviour */
                    $('.modal-open').removeClass('modal-open')
                }, 500)
            },
            // addTag (newTag) {
            //     let self = this
            //     console.log('newTAg', newTag)
            //     const tag = {
            //         name: newTag
            //     }
            //     if (self.verifyEmail(newTag)) {
            //         self.emailList.push(tag)
            //         this.taggedEmails.push(tag)
            //         console.log('tagged emails', this.taggedEmails)
            //     } else {
            //         console.log('invalid email address, calling swal')
            //     }
            // },
            verifyEmail (email) {
                if (email.length > 0) {
                    let re = /\S+@\S+\.\S+/
                    if (!re.test(email)) {
                        return false
                    } else {
                        return true
                    }
                } else {
                    return false
                }
            },
            onSharePlaylist () {
                let self = this
                self.spinnerToggle()
                let emailArray = self.taggedEmails.map(x => {
                    return x.name
                })
                self.sharePayload.sharedPlaylistPreview = `${self.user.firstName} shared a coaching tips playlist with you on Tone Networks: \n${self.archiveEventTitle}\n${self.sharePayload.sharedEmailMessage}`
                let sharePayload = {
                    csvEmailRecepients: emailArray.join(','),
                    userId: self.user.userId,
                    playlistId: self.archiveEventId,
                    customizedMessage: self.sharePayload.sharedPlaylistPreview
                }
                self.$store.dispatch('ARCHIVE_PLAYLIST_SHARE', {payload: sharePayload}).then(() => {
                    if (!self.error.show) {
                        self.spinnerToggle()
                        self.$store.dispatch('GET_TAGGED_EMAIL_LIST', self.user.userId).then(() => {
                            if (self.getTaggedEmailList) {
                                self.emailList = []
                                self.emailList = self.getTaggedEmailList
                                self.taggedEmails = []
                                self.sharePayload.sharedPlaylistPreview = ''
                            }
                        })
                        self.$swal({
                            title: 'Email Sent!',
                            text: '',
                            type: 'success',
                            timer: 3000,
                            showCancelButton: false,
                            showConfirmButton: false
                        }).then(
                            function () {
                            },
                            // handling the promise rejection
                            function (dismiss) {
                                if (dismiss === 'timer') {
                                }
                            }
                        )
                        self.cancelEmailShareModal()
                    } else {
                        self.spinnerToggle()
                        self.cancelEmailShareModal()
                    }
                })
            },
            openModalShare (eventId, eventTitle) {
                console.log('called')
                this.archiveEventId = eventId
                this.archiveEventTitle = eventTitle
                this.showSharedModal = true
            },
            playVideoArchive (eventId, eventTitle) {
                this.$router.push(`/tonearchive/${eventId}/play/1/${eventTitle.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()}`)
                // location.reload()
            },
            setVideoPlayerObject (videoObject) {
                if (videoObject.marketing) {
                    this.openModal(videoObject)
                } else {
                    if (this.user && this.getTrialDays < 0) {
                        if (sessionStorage.getItem('redirectPath')) {
                            sessionStorage.removeItem('redirectPath')
                            sessionStorage.setItem('redirectPath', `/watch/${videoObject.videoCode}`)
                        } else {
                            sessionStorage.setItem('redirectPath', `/watch/${videoObject.videoCode}`)
                        }
                        this.$router.push(`/becomemember`)
                    } else if (this.user) {
                        this.$router.push('/watch/' + videoObject.videoCode)
                    } else {
                        this.$router.push('/watch/' + videoObject.videoCode)
//                        if (sessionStorage.getItem('redirectPath')) {
//                            sessionStorage.removeItem('redirectPath')
//                            sessionStorage.setItem('redirectPath', `/watch/${videoObject.videoCode}`)
//                        } else {
//                            sessionStorage.setItem('redirectPath', `/watch/ ${videoObject.videoCode}`)
//                        }
//                        store.commit('setTriggerLogin', {loginStatus: true})
                    }
                }
            },
            cancelModal () {
                var self = this
                var $ = window.jQuery
                setTimeout(function () {
                    self.showModal = false
                    self.showWatchVideoModal = false
                    /* remove the class added by default by modal, when open to retain the scrolling behaviour */
                    $('.modal-open').removeClass('modal-open')
                }, 500)
            },
            openModal (mainVideoObj) {
                let self = this
                if (!this.expertEvent) {
                    if (self.currentVideoRef) {
//                        console.log('referenece found as: ', self.currentVideoRef)
                        window.jwplayer(self.currentVideoRef).pause(true)
                    } else {
                        self.currentVideoRef = window['currentVideoId']
                        window.jwplayer(self.currentVideoRef).pause(true)
//                        console.log('referenece not found as: ', self.currentVideoRef)
                    }
                    // window.jwplayer(window['currentVideoId']).pause(true)
                }
                this.currentPlayerID = {video: mainVideoObj.sources[mainVideoObj.sources.length - 1].file, title: mainVideoObj.title, img: mainVideoObj.image, playerID: new Date(), tracks: mainVideoObj.tracks, videoDescription: mainVideoObj.longdescription}
                this.showWatchVideoModal = true
                this.currentVideoDesc = mainVideoObj.description
            },
            getDateReference (dte, type) {
                let dt = new Date(dte)
                let dayStr, monStr
                let eDay = dt.getDate()
                let eHours = this.getHoursFormatted(dt)
                let eMonth = dt.getMonth() + 1
                let day
                // Set Day of Date
                if (dt.getDay() === 0) {
                    day = 'Sunday'
                } else if (dt.getDay() === 1) {
                    day = 'Monday'
                } else if (dt.getDay() === 2) {
                    day = 'Tuesday'
                } else if (dt.getDay() === 3) {
                    day = 'Wednesday'
                } else if (dt.getDay() === 4) {
                    day = 'Thursday'
                } else if (dt.getDay() === 5) {
                    day = 'Friday'
                } else if (dt.getDay() === 6) {
                    day = 'Saturday'
                } else {
                    day = ''
                }
                // Set Date Pattern
                if (eDay === 1) {
                    dayStr = '1st'
                } else if (eDay === 2) {
                    dayStr = '2nd'
                } else if (eDay === 3) {
                    dayStr = '3rd'
                } else if (eDay === 21) {
                    dayStr = '21st'
                } else if (eDay === 22) {
                    dayStr = '22nd'
                } else if (eDay === 23) {
                    dayStr = '23rd'
                } else if (eDay === 31) {
                    dayStr = '31st'
                } else {
                    dayStr = eDay + 'th'
                }
                // Set Month
                if (eMonth === 1) {
                    monStr = 'January'
                } else if (eMonth === 2) {
                    monStr = 'February'
                } else if (eMonth === 3) {
                    monStr = 'March'
                } else if (eMonth === 4) {
                    monStr = 'April'
                } else if (eMonth === 5) {
                    monStr = 'May'
                } else if (eMonth === 6) {
                    monStr = 'June'
                } else if (eMonth === 7) {
                    monStr = 'July'
                } else if (eMonth === 8) {
                    monStr = 'August'
                } else if (eMonth === 9) {
                    monStr = 'September'
                } else if (eMonth === 10) {
                    monStr = 'October'
                } else if (eMonth === 11) {
                    monStr = 'November'
                } else if (eMonth === 12) {
                    monStr = 'December'
                }
                if (type === 'btn') {
                    return 'Reserve your spot starting ' + monStr + ' ' + dayStr + '!'
                } else if (type === 'live') {
                    return monStr + ' ' + eDay
                } else if (type === 'live2') {
                    return day + ', ' + monStr + ' ' + dayStr + ' at ' + eHours + ' ET'
                } else if (type === 'str') {
                    return day + ', ' + monStr + ' ' + dayStr + ' at ' + eHours + ' ET'
                } else {
                    return day + ', ' + monStr + ' ' + dayStr + ' @' + eHours + ' ET'
                }
            },
            getHoursFormatted (time) {
                let hours = time.getHours()
                let minutes = time.getMinutes()
                let ampm = hours >= 12 ? 'pm' : 'am'
                hours = hours % 12
                hours = hours === 0 ? '12' : hours
                minutes = minutes < 10 ? '0' + minutes : minutes
                let strTime = hours + ':' + minutes + ' ' + ampm
                return strTime
            },
            isUserEntrolled (eventId) {
                if (this.getUserEvents) {
                    let filter = this.getUserEvents.filter(ev => {
                        return ev.eventId === eventId
                    })
                    if (filter && filter.length > 0) {
                        return true
                    }
                }
                return false
            },
            getMinutesBetweenDates (startDate, endDate) {
                var diff = endDate.getTime() - startDate.getTime()
                return (diff / 60000)
            },
            returnEasternTime () {
                let offset = -5
                if (dateHelpers.dstEnabled(new Date())) {
                    offset = -4.0
                }
                let clientDate = new Date()
                let utc = clientDate.getTime() + (clientDate.getTimezoneOffset() * 60000)
                let serverDate = new Date(utc + (3600000 * offset))
                return serverDate
            },
            isEventToday2 (evtDate, endDate, eventSwtichTime, defaultSwitchTime) {
                let eventDate = new Date(evtDate)
                let eventEndDate = new Date(endDate)
                let currentDate = this.returnEasternTime()
                let switchTime = parseInt(defaultSwitchTime)
                if (eventSwtichTime && (eventSwtichTime !== null || eventSwtichTime !== undefined) && eventSwtichTime > 0) {
                    switchTime = parseInt(eventSwtichTime)
                }
                // console.log('time left', this.getMinutesBetweenDates(currentDate, eventDate))
                if (eventDate.getDate() === currentDate.getDate() && eventDate.getMonth() + 1 === currentDate.getMonth() + 1 && eventDate.getFullYear() === currentDate.getFullYear()) {
                    if (this.getMinutesBetweenDates(currentDate, eventDate) <= switchTime && this.getMinutesBetweenDates(currentDate, eventEndDate) >= 0) {
                        return true
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            },
            showJoin (bEvent) {
                if (bEvent) {
                    if (this.isEventToday2(bEvent.start_date, bEvent.end_date, bEvent.eventSwitchTime, this.getEventSwitchTime)) {
                        return true
                    }
                }
                return false
            },
            isEventToday (evtDate, endDate) {
                let eventDate = new Date(evtDate)
                let eventEndDate = new Date(endDate)
                let currentDate = this.returnEasternTime()
                // console.log('time left', this.getMinutesBetweenDates(currentDate, eventDate))
                if (eventDate.getDate() === currentDate.getDate() && eventDate.getMonth() + 1 === currentDate.getMonth() + 1 && eventDate.getFullYear() === currentDate.getFullYear()) {
                    if (this.getMinutesBetweenDates(currentDate, eventDate) <= 15 && this.getMinutesBetweenDates(currentDate, eventEndDate) >= 0) {
                        return true
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            },
            enrollUser (event) {
                this.seatReservation.eventId = event.eventId
                this.seatReservation.userId = this.user.userId
                this.seatReservation.status = '1'
                this.seatReservation.isAnonymous = '0'
                this.$store.dispatch('SEATRESERVATION', this.seatReservation).then(() => {
                    this.$store.dispatch('GETALLEXPERTS').then(() => {
                    })
                    this.$store.dispatch('GETUSEREVENTS', this.user.userId).then(() => {
                    })
                })
            },
            addNewPlayList () {
                if (this.newPlaylistName && this.newPlaylistName.length > 0) {
                    let payload = {}
                    payload.userId = this.user.userId
                    payload.title = this.newPlaylistName
                    this.$store.dispatch('CREATEPLAYLIST', {playlist: payload}).then(() => {
                        this.newPlaylistName = ''
                        // this.charities = this.getAuthUserVideos
                    })
                }
            },
            showPlaylistMenu (videoCode) {
                $('#' + videoCode + ' + ul').toggleClass('hide')
            },
            hidePlaylistMenu (videoCode) {
                // console.log(videoCode)
                $('#' + videoCode + ' + ul').toggleClass('hide')
            },
            setPlaylistVideoStatus (video, playlist, currentStatus) {
                let self = this
                self.selectedVideo = video.mediaid
                self.selectedPlaylist = playlist.playlistId
                if (currentStatus) { // Video is unSelected
                    let payload = {}
                    payload.videoCode = video.mediaid
                    payload.userPlaylistId = playlist.playlistId
                    payload.userId = this.user.userId
                    this.$store.dispatch('REMOVEVIDEOFROMPLAYLIST', {playlist: payload}).then(() => {
                        self.videoAdded = false
                        self.videoRemoved = true
                    })
                } else { // Video is Selected
                    let payload = {}
                    payload.videoCode = video.mediaid
                    payload.userId = this.user.userId
                    payload.userPlaylistId = playlist.playlistId
                    this.$store.dispatch('ADDVIDEOINPLAYLIST', {playlist: payload}).then(() => {
                        // this.charities = this.getAuthUserVideos
                        self.videoAdded = true
                        self.videoRemoved = false
                    })
                }
                setTimeout(() => {
                    self.videoAdded = false
                    self.videoRemoved = false
                }, 1500)
            },
            verifyPlaylistExists () {
                if (this.getUserPlaylists) {
                    let playlistsWithVideo = this.getUserPlaylists.filter(x => {
                        return x.userPlaylistVideos !== null
                    })
                    if (playlistsWithVideo && playlistsWithVideo.length > 0) {
                        return true
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            },
            verifyVideoExists (playlist, video) {
                let self = this
                if (this.getUserPlaylists) {
                    let findPlaylist = this.getUserPlaylists.filter(x => {
                        return x.playlistId === playlist.playlistId
                    })
                    if (findPlaylist && findPlaylist.length > 0) {
                        if (findPlaylist[0].userPlaylistVideos !== null && findPlaylist[0].userPlaylistVideos.length > 0) {
                            let videos = findPlaylist[0].userPlaylistVideos.filter(x => {
                                return x.videoCode === video.mediaid
                            })
                            if (videos && videos.length > 0) {
                                self.playlistHasVideo = true
                                return true
                            } else {
                                return false
                            }
                        } else {
                            return false
                        }
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            },
            getVideoStatus (videoObject) {
                if (this.getAuthUserVideos) {
                    let mediaId = videoObject.mediaid
                    let exists = this.getAuthUserVideos.filter(videoObject => {
                        return videoObject.videoCode === mediaId
                    })
                    if (exists && exists.length > 0 && exists[0].liked === '1') {
                        return true
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            },
            setVideoStatus (videoObject) {
                if (this.getAuthUserVideos) {
                    let mediaId = videoObject.mediaid
                    let exists = this.getAuthUserVideos.filter(videoObject => {
                        return videoObject.videoCode === mediaId
                    })
                    if (exists && exists.length > 0) {
                        if (exists[0].liked === '1') {
                            exists[0].liked = '0'
                        } else {
                            exists[0].liked = '1'
                        }
                        this.$store.dispatch('SETVIDEOSTATUS', exists[0]).then(() => {
                            this.$store.dispatch('GETAUTHUSERVIDEOS', this.user.userId)
                        })
                    } else {
                        let logWatchedEntry = {
                            videoCode: videoObject.mediaid,
                            userId: this.user.userId,
                            playlistId: null,
                            playlistCode: null,
                            watched: 'N',
                            rating: null,
                            liked: '1',
                            durationWatched: 0,
                            thumbnailURL: null,
                            opinion: null
                        }
                        this.$store.dispatch('SETVIDEOSTATUS', logWatchedEntry).then(() => {
                            this.$store.dispatch('GETAUTHUSERVIDEOS', this.user.userId)
                        })
                    }
                }
            },
            verifyVideoStatus (videoCode) {
                if (this.getExpertVideos) {
                    let getStatus = this.topVideos.filter(x => {
                        return x.mediaid === videoCode
                    })
                    if (getStatus && getStatus.length > 0) {
                        return true
                    } else {
                        return false
                    }
                }
            },
            createSlickCarousal () {
                $.slick = slick
                const $slick = $(this.$el).find('.responsive-slick-slider')
                $slick.slick({
                    dots: false,
                    infinite: false,
                    speed: 300,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    responsive: [{
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            infinite: false,
                            dots: false
                        }
                    }, {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }, {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }]
                })
            }
        },
        computed: {
            ...mapGetters([
                'isUserLoggedIn', 'getCorporatePayload', 'user', 'isScrolled', 'getExpert', 'getExpertVideos', 'getEventList', 'getUserEvents', 'getVideosFlag', 'getExpertPlaylist', 'getUserPlaylists', 'getAuthUserVideos', 'getTrialDays', 'getEventSwitchTime', 'getExpertArchiveClips', 'getTaggedEmailList', 'error', 'getCorpHeaderColor', 'getCorpFooterColor', 'getCorpButtonColor', 'getCorpHeadingColor', 'getExpertNextEvent']
            )
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .row.yourFaves {
        display: flex;
        flex-wrap: wrap;
    }
    .expert-page-wrapper .main h2 {
        margin-top: 0;
    }
    h2.pinkh2{
        font-size: 29px;
        /*color: #f0617d !important;*/
        text-transform: uppercase;
        font-weight:700;
    }
    .expert-page-wrapper .random .blog-section h2.pinkh2{
        font-size: 29px;
        /*color: #f0617d !important;*/
        text-transform: uppercase;
    }
    .blog-section.videossection.clearfix .panel .panel-body > .col-md-12.margin-top-20.margin-bottom-40 {
        margin: 10px 0;
        padding: 0;
    }

    .blog-section.videossection.clearfix .panel .panel-body > .col-md-12.margin-top-20.margin-bottom-40 p {
        font-size: 15px;
    }

    .blog-section.videossection.clearfix .panel .panel-body > .col-md-12.margin-top-20.margin-bottom-40 > p > i.fa.fa-play-circle-o {
        position: relative;
        font-size: 25px;
        width: auto !important;
        color:black;
        margin-right:10px;
        top:3px
    }
    .blog-section.videossection.clearfix .panel .panel-body {
        cursor: pointer;
    }
    img.img-responsive {
        width: 100%;
    }
    .expert-page-wrapper .main img{height:auto;}
    .expert-page-wrapper .live-chat
    img.nostyle {
        width: auto;
        height: auto;
        max-width: 90%;
        float: left;
    }
    .experts h2 {
        margin-top: 5px;
    }
    .pintlist-holder {padding: 0 0 50px;}
    ul.pink_container {
        padding: 20px;
        color: #f0617d;
        font-weight: 700;
        font-size: 18px;
        margin: 30px 0;
        border: 2px solid #f0617d;
        list-style: none;
    }

    ul.pink_container li {
        line-height: 1.3;
        padding: 0 0 10px;
    }
    .btn-group.plusicon {
        position: absolute;
        right: 50px;
        bottom: 0px;
        height: 29px;
        z-index:200;
    }
    li.divider {
        border-bottom: 1px solid #ddd;
        margin: 5px -15px;
    }

    button.dropdown-toggle.ellipsis.pull-right {
        background: transparent;
        border: 0 none transparent;
        padding: 0;
    }
    button.dropdown-toggle.ellipsis.pull-right{
        font-size: 21px;
        top: 0;
    }
    button.dropdown-toggle.ellipsis.pull-right li label{
        padding: 30px;
    }
    button.dropdown-toggle.ellipsis.pull-right+ ul li label,
    button.dropdown-toggle.ellipsis.pull-right+ ul li a {
        padding: 3px 15px;
        margin-bottom: 5px;
        display: block;
    }
    button.dropdown-toggle.ellipsis.pull-right+ ul li input.form-control,
    button.dropdown-toggle.ellipsis.pull-right+ div + ul li input.form-control {
        height: 30px;
        padding: 5px 30px 5px 5px;
    }
    button.dropdown-toggle.ellipsis.pull-right+ ul li input.form-control + i.fa.fa-plus-circle,
    button.dropdown-toggle.ellipsis.pull-right+ div + ul li input.form-control + i.fa.fa-plus-circle {
        position: absolute;
        top: 6px;
        font-size:24px;
        right:20px;
        cursor: pointer;
    }
    button.dropdown-toggle.ellipsis.pull-right+ ul li label,
    button.dropdown-toggle.ellipsis.pull-right+div + ul li label{
        position:relative;
    }
    button.dropdown-toggle.ellipsis.pull-right+ div + ul,
    button.dropdown-toggle.ellipsis.pull-right+ ul{
        left: 0;
        right: auto;
        width: 230px;
        background: #fff;
        border: 1px solid #ddd;
        border-radius: 5px;
        top: 100%;
        position: absolute;
        z-index: 5000;
        list-style: none;
        text-align: left;
        padding: 15px;
    }
    .backdropformenu{
        position:fixed;
        z-index:4900;
        top:0;
        left:0;
        right:0;
        bottom:0;
        background: transparent;
    }
    .profile .tabContent .menuiconbutton{
        height: 24px;
        width: 37px;
    }
    .menuiconbutton{
        height: 24px;
        width: 37px;
    }
    .plusicon.btn-group > button.dropdown-toggle.ellipsis.pull-right+ul {
        left: auto ;
        right: 0;
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }

    label.notificationwithcheckboxes span{
        font-size: 10px;
    }

    span.removed {
        color: red;
    }
    span.added {
        color: #4caa98;
    }

    label.notificationwithcheckboxes {
        position: relative;
        display:block;
    }


    label.notificationwithcheckboxes {}
    .career-page-wrapper .featured .experts p{
        font-weight:normal;    }
    .row.yourFaves p.text-wrap-title.cursor {
        text-align: left;
        font-size: 15px;
        white-space: nowrap;
        font-weight: normal;
        line-height: 1.8;
        color: #5e5e5e;
        margin-top:10px;
        overflow:hidden;
        text-overflow:ellipsis;
    }

    .row.yourFaves p.text-wrap-title.cursor i.fa.fa-play-circle-o {
        position: relative;
        font-size: 25px;
        width: auto !important;
        color: black;
        margin-right: 10px;
        top: 3px;
    }
    .row.yourFaves hr {
        margin: 0;
    }

    .row.yourFaves p.right-heart-icon {
        text-align: right;
        top: 10px;
        position: relative;
        z-index: 100;
    }

    .row.random-section-head.yourFaves.exceptionalsettings
    p.text-wrap-title.cursor i.fa.fa-play-circle-o{
        height:20px !important;
    }

    .row.random-section-head.yourFaves.exceptionalsettings
    .plusicon.btn-group {
        bottom:15px;
    }
    @media(min-width:992px){
        .row.random-section-head.yourFaves.exceptionalsettings .col-xs-12.col-sm-6.col-md-4.bottom-margin:nth-of-type(3n + 1) {
            clear: left;
        }
    }
    @media(max-width:767px){
        .expert-page-wrapper .live-chat img.nostyle{
            max-width:100% ;
        }
    }
    .show-share-options {
        position: relative;
    }

    .show-share-options .favnumbers {
        position: absolute;
        background: #f0617d;
        top: 0;
        right: 0;
        width: 50px;
        bottom: 0;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        font-size: 30px;
        font-weight: bold;
        color: #fff;
    }

    .show-share-options .favnumbers small {
        font-size: 11px;
        display: block;
        line-height: 1;
    }

    .show-share-options .favnumbers > div {
        line-height: 1;
    }

    @media(min-width:768px){
        .show-share-options .favnumbers{
            display:none;
        }
    }
    .show-share-options:hover .favnumbers{
        display:flex;
    }
    /*Changes for Corporate Modal*/
    .sharesmallpink.watchVideoModal .modal-dialog  .watchVideoModalHeader {
        background: #f0617d;
        color: #fff;
        font-size: 25px;
        text-align: left;
        padding: 15px 25px;
        font-weight: 700;
    }
    .sharesmallpink.watchVideoModal .modal-dialog .modal-body p{
        padding: 0;
        margin: 0 0 20px;
    }

    .sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.buttonsinpopup button.btn.btn-default {
        background: #fff;
        color: #333;
        border: 1px solid #cacaca;
        width: 100%;
    }

    .sharesmallpink.watchVideoModal .modal-dialog .modal-body {
    }

    .sharesmallpink.watchVideoModal .modal-dialog .modal-body button.btn.btn-primary.btn-pink {
        background: #f0617d;
        width: 100%;
        margin: 0;
        border: 1px solid #f0617d;
    }
    @media(max-width:475px){
        .sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.buttonsinpopup button.btn.btn-default {
            padding-left: 0;
            padding-right: 0;
        }
    }
    .row.sharefb {
        background: #eee;
        margin-left: 0;
        margin-right: 0;
    }

    .row.sharefb > div {
        padding: 5px;
        text-align: left;
    }

    .row.sharefb .col-sm-5 img {
        max-width: 100%;
    }
    .sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb p {
        font-size: 14px;
        font-weight: 300;
    }

    .sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb h6 {
        text-transform: uppercase;
        font-size: 12px;
        margin: 10px 0 5px;
    }

    .sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb h4 {
        margin: 0 0 5px;
        font-weight:700;
    }
    .showmobile{display:none;}
    @media(max-width:767px){
        .usernamenimg.text-left {
            display: none;
        }
        .showmobile{
            display: block;
        }
        .alert.alert-default {
            background: #eee;
        }

        .sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb p {
            display: none;
        }
        .sharesmallpink.watchVideoModal .modal-dialog .watchVideoModalHeader .watchVideoArrow {
            top: 1px;
            right: -13px;
        }
        .row.sharefb {
            display: flex;
            align-items: center;
        }
        .pinksidebarmin{
            padding:0 !important;
            display: flex;
            flex-direction: column;
            flex-basis: auto;
            display: flex ;
            align-items: stretch ;
            justify-content: center;
        }

        .pinksidebarmin > * {
            padding: 6px 0 !important;
            margin: 0 !important;
            flex: 100;
            text-align:center;
        }
    }
</style>



// WEBPACK FOOTER //
// Expert.vue?3c351e16